import React, { useState, useEffect } from "react";
import { Card, Skeleton, Box, Divider, Typography } from "@mui/material";
import StatCards from "./StatCards/StatCards";
import useAxios from "../../../api/useAxios";
import SkeletonSeekCard from "../admin-components/StatCards/SkeletonSeekCard";
function Dashboard() {
  const [getApi, setGetApi] = useState([]);
  const [getEmployer, setGetEmployer] = useState([]);
  // const [getVolunteer, setGetVolunteer] = useState([]);
  const [getHelpforjs, setGetHelpforjs] = useState([]);
  const [getMentor, setGetMentor] = useState([]);
  const [getServiceProvider, setGetServiceProvider] = useState([]);
  const [getInvestor, setGetInvestor] = useState([]);
  const [getPartner, setGetPartner] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const axiosData = useAxios();
  const fetchApi = async () => {
    try {
      const useAxiosData = await axiosData.get("seekers");
      const { data } = useAxiosData;

      if (useAxiosData.status === 204) {
        setGetApi([]);
      } else {
        setGetApi(data);
      }
    } catch (err) {
      console.log("Error", err);
    }
  };

  const fetchEmpApi = async () => {
    try {
      const useAxiosData1 = await axiosData.get("mentor");
      const { data } = useAxiosData1;

      if (useAxiosData1.status === 204) {
        setGetMentor([]);
      } else {
        setGetMentor(data);
      }
      // setGetEmployer(data);
      // setIsLoading(false);
    } catch (err) {
      console.log("Error", err);
    }
  };
  const fetchVolApi = async () => {
    try {
      const useAxiosData1 = await axiosData.get("employers");
      const { data } = useAxiosData1;

      if (useAxiosData1.status === 204) {
        setGetEmployer([]);
      } else {
        setGetEmployer(data);
      }
      // setGetEmployer(data);
    } catch (err) {
      console.log("Error", err);
    }
  };
  const fetchHelpForJsApi = async () => {
    try {
      const useAxiosData1 = await axiosData.get("helpforjobseeker");
      const { data } = useAxiosData1;

      if (useAxiosData1.status === 204) {
        setGetHelpforjs([]);
      } else {
        setGetHelpforjs(data);
      }
      // setGetHelpforjs(data);
    } catch (err) {
      console.log("Error", err);
    }
  };
  // const fetchMentorApi = async () => {
  //   try {
  //     const useAxiosData1 = await axiosData.get("volunteer");
  //     const { data } = useAxiosData1;

  //     if (useAxiosData1.status === 204) {
  //       setGetVolunteer([]);
  //     } else {
  //       setGetVolunteer(data);
  //     }
  //     // setGetEmployer(data);
  //     setIsLoading(false);
  //   } catch (err) {
  //     console.log("Error", err);
  //   }
  // };
  const fetchServiceProviderApi = async () => {
    try {
      const useAxiosData1 = await axiosData.get("localserviceprovider");
      const { data } = useAxiosData1;

      if (useAxiosData1.status === 204) {
        setGetServiceProvider([]);
      } else {
        setGetServiceProvider(data);
      }
      setIsLoading(false);
    } catch (err) {
      console.log("Error", err);
    }
  };
  const fetchInvestorApi = async () => {
    try {
      const useAxiosData1 = await axiosData.get("investors");
      const { data } = useAxiosData1;

      if (useAxiosData1.status === 204) {
        setGetInvestor([]);
      } else {
        setGetInvestor(data);
      }
      setIsLoading(false);
    } catch (err) {
      console.log("Error", err);
    }
  };
  const fetchPartnerApi = async () => {
    try {
      const useAxiosData1 = await axiosData.get("partners");
      const { data } = useAxiosData1;

      if (useAxiosData1.status === 204) {
        setGetPartner([]);
      } else {
        setGetPartner(data);
      }
      setIsLoading(false);
    } catch (err) {
      console.log("Error", err);
    }
  };
  useEffect(() => {
    fetchApi();
    fetchEmpApi();
    fetchVolApi();
    fetchHelpForJsApi();
    // fetchMentorApi();
    fetchServiceProviderApi();
    fetchInvestorApi();
    fetchPartnerApi();
  }, []);
  if (!isLoading) {
    const getAll = [
      { name: "Job Seekers Data", data: getApi },
      { name: "Employers Data", data: getEmployer },
      // { name: "Volunteers Data", data: getVolunteer },
      { name: "Help for Job seekers Data", data: getHelpforjs },
      { name: "Mentors Data", data: getMentor },
      { name: "Service Providers Data", data: getServiceProvider },
      { name: "Investors Data", data: getInvestor },
      { name: "Partners Data", data: getPartner },
    ];
    return (
      <Box sx={{ p: 4, backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
        {/* Dashboard Header */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" sx={{ fontWeight: 800, color: "#1e293b", mb: 1 }}>
            Dashboard Overview
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Real-time statistics across all registration categories
          </Typography>
        </Box>

        {getAll.map((item, index) => (
          <Box key={index} sx={{ mb: 6 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
              <Box sx={{ width: 6, height: 24, borderRadius: 1, backgroundColor: "#339fcd" }} />
              <Typography variant="h6" sx={{ fontWeight: 800, color: "#334155", letterSpacing: -0.5 }}>
                {item.name}
              </Typography>
              <Divider sx={{ flexGrow: 1, opacity: 0.5 }} />
            </Box>
            <StatCards getApi={item.data} />
          </Box>
        ))}
      </Box>
    );
  } else {
    return (
      <>
        {" "}
        <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <Card sx={{ padding: "20px", borderRadius: "20px" }}>
            <Skeleton
              animation="wave"
              variant="text"
              width={230}
              height={40}
              sx={{ borderRadius: "15px" }}
            />
          </Card>

          <Card>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                paddingTop: "20px",
                gap: "10px",
              }}
            >
              {" "}
              <Skeleton
                animation="wave"
                variant="text"
                width={230}
                height={40}
                sx={{ borderRadius: "15px" }}
              />
              <SkeletonSeekCard />
            </Box>
          </Card>
          <Card>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                paddingTop: "20px",
                gap: "10px",
              }}
            >
              {" "}
              <Skeleton
                animation="wave"
                variant="text"
                width={230}
                height={40}
                sx={{ borderRadius: "15px" }}
              />
              <SkeletonSeekCard />
            </Box>
          </Card>
        </Box>
      </>
    );
  }
}

export default Dashboard;
